import React from 'react';
import formatNumberWithComma from '../../../../lib/utils/common/formatComma';

interface IBrandDiscountRateTabContent {
  brandDiscountRateType: 'rate' | 'amount';
  couponDiscountAmount: number;
  brandShareAmount: number | undefined;
  couponDiscountType: number;
}

const BrandDiscountRateTabContent = (props: IBrandDiscountRateTabContent) => {
  const { brandDiscountRateType, couponDiscountAmount, brandShareAmount, couponDiscountType } = props;

  const brandDiscountRateTypeAmountText = brandDiscountRateType === 'rate' ? '%' : '원';

  const couponDiscountTypeAmountText = couponDiscountType === 1 ? '%' : '원';
  const couponDiscountTypeNameText = couponDiscountType === 1 ? '정률 할인' : '정액 할인';

  return (
    <>
      <div className="info">
        쿠폰의 {couponDiscountTypeNameText}에서 입력한 ({couponDiscountTypeAmountText}
        )만큼 브랜드가 분담합니다.
      </div>
      <div className="setting">
        <span className="price">
          {couponDiscountAmount}
          {couponDiscountTypeAmountText}
        </span>

        <span className="text">{' 할인에서'}</span>

        <span className="price">
          {' '}
          {brandShareAmount ? formatNumberWithComma(brandShareAmount) : ' 0'}
          {brandDiscountRateTypeAmountText}
        </span>

        <span className="text">브랜드가 분담합니다.</span>
      </div>
    </>
  );
};

export default BrandDiscountRateTabContent;
